<div class="export-modal-container">
  <form [formGroup]="LoginSapForm">
    <div class="centrar-row-container">
      <mat-label style="text-align: center;">Hola {{ nombreUsuario }}, ¿cuánto sientes que te ha ayudado la plataforma en tus<br>actividades operativas para el programa Impulso?
        </mat-label> 
    </div>

    <div class="mb-2">
      <div>
        <div class="button-container">
          <div *ngFor="let item of ListaCalifacion">
            <button type="button" [ngClass]="getButtonClass(item)" class="custom-button"
              (click)="onButtonClick(item)">
              {{ item }}
            </button>
          </div>
        </div>
      </div>
      <div>
        <mat-label class="label-bottom-left">Muy poco</mat-label>
        <mat-label class="label-bottom-right">Bastante</mat-label>
      </div>
    </div>

      <div class="textarea-container">
        <mat-label class="label-comment">¡Ayúdanos a ser mejores! Escribe tus comentarios aquí.</mat-label>  
        <!--<mat-label class="label-top-right">Bastante</mat-label>-->  
        <mat-form-field appearance="outline" class="Mat-Form-Field">
          <textarea (input)="onChangeTxt($event)" matInput type="text" id="strcomentario" name="strcomentario" formControlName="strcomentario"
            class="txtarea" placeholder="¿Qué mejorarías en nuestra plataforma? o ¿Qué es lo que más valoras de nuestra plataforma?"></textarea>
        </mat-form-field> 
        <mat-label class="label-bot-right">{{intCantCaracteres}}/250</mat-label>    
      </div>

      <div class="row-columnas">
        <button type="button" mat-flat-button class="button-enviar" (click)="Enviar()">Enviar</button>
      </div>
    
  </form>

</div>  
